import { AudioPitchStretchBoxAdapter } from "./AudioPitchStretchBoxAdapter";
import { AudioTimeStretchBoxAdapter } from "./AudioTimeStretchBoxAdapter";
import { AudioSignalsmithBoxAdapter } from "./AudioSignalsmithBoxAdapter";
export var AudioPlayMode;
(function (AudioPlayMode) {
    AudioPlayMode.isAudioPlayMode = (mode) => mode instanceof AudioPitchStretchBoxAdapter
        || mode instanceof AudioTimeStretchBoxAdapter
        || mode instanceof AudioSignalsmithBoxAdapter;
})(AudioPlayMode || (AudioPlayMode = {}));
